import {
  addProxy,
  deleteProxy,
} from "../../../application/requests/proxiesRequests";
import {
  GET_PROXIES_REQUEST,
  GET_PROXIES_REQUEST_SUCCESS,
  GET_PROXIES_REQUEST_FAILURE,
  GET_PROXY_SETTINGS_REQUEST,
  GET_PROXY_SETTINGS_REQUEST_SUCCESS,
  GET_PROXY_SETTINGS_REQUEST_FAILURE,
  UPDATE_PROXY_SETTING_REQUEST,
  UPDATE_PROXY_SETTING_REQUEST_SUCCESS,
  UPDATE_PROXY_SETTING_REQUEST_FAILURE,
  ADD_PROXY_REQUEST,
  ADD_PROXY_REQUEST_SUCCESS,
  ADD_PROXY_REQUEST_FAILURE,
  DELETE_PROXY_REQUEST,
  DELETE_PROXY_REQUEST_SUCCESS,
  DELETE_PROXY_REQUEST_FAILURE,
  REFRESH_PROXY_REQUEST,
  REFRESH_PROXY_REQUEST_SUCCESS,
  REFRESH_PROXY_REQUEST_FAILURE,
} from "./mutation-types";
import api from "@/application";

const actions = {
  getProxies: async ({ commit }) => {
    commit(GET_PROXIES_REQUEST);

    try {
      const { data } = await api.proxies.getProxies();
      commit(GET_PROXIES_REQUEST_SUCCESS, data);
    } catch (e) {
      commit(GET_PROXIES_REQUEST_FAILURE);
      throw new Error(e.response?.data?.errorMessage);
    }
  },

  getProxySettings: async ({ commit }) => {
    commit(GET_PROXY_SETTINGS_REQUEST);

    try {
      const { data } = await api.proxies.getProxySettings();
      commit(GET_PROXY_SETTINGS_REQUEST_SUCCESS, data);
    } catch (e) {
      commit(GET_PROXY_SETTINGS_REQUEST_FAILURE);
      throw new Error(e.response?.data?.errorMessage);
    }
  },

  updateProxySetting: async ({ commit }, request) => {
    commit(UPDATE_PROXY_SETTING_REQUEST);
    try {
      const { data } = await api.proxies.updateProxySettings(request);
      commit(UPDATE_PROXY_SETTING_REQUEST_SUCCESS, data);
    } catch (e) {
      commit(UPDATE_PROXY_SETTING_REQUEST_FAILURE);
      throw new Error(e.response?.data?.errorMessage);
    }
  },

  addProxy: async ({ commit }, request) => {
    commit(ADD_PROXY_REQUEST);
    try {
      const { data } = await addProxy(request);
      commit(ADD_PROXY_REQUEST_SUCCESS, data);
    } catch (e) {
      commit(ADD_PROXY_REQUEST_FAILURE);
      throw new Error(e.response?.data?.errorMessage);
    }
  },

  deleteProxy: async ({ commit }, id) => {
    commit(DELETE_PROXY_REQUEST);
    try {
      const { data } = await deleteProxy(id);
      commit(DELETE_PROXY_REQUEST_SUCCESS, data);
    } catch (e) {
      commit(DELETE_PROXY_REQUEST_FAILURE);
      throw new Error(e.response?.data?.errorMessage);
    }
  },

  refreshProxy: async ({ commit }, { id, source }) => {
    commit(REFRESH_PROXY_REQUEST);
    try {
      const { data } = await api.proxies.refreshProxy(id, source);
      commit(REFRESH_PROXY_REQUEST_SUCCESS, data);
    } catch (e) {
      commit(REFRESH_PROXY_REQUEST_FAILURE);
      throw new Error(e.response?.data?.errorMessage);
    }
  },
};

export default actions;
